import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import DashboardLayout from "../layout/Dashboard";
import { FormattedMessage } from "react-intl";
import { Messages } from "../../components/layout/Messages/Messages";
import { getPackageDetails as getPackageDetailsApi } from "../../api/clients/packages";
import { PackageDetails } from "../../components/pages/documents/PackageDetails";
import { NOTIFICATION_VIEW_DOCUMENT } from '../../config/notifications';
import { ACL, PAGE_CONTEXTS } from '../../config/constants';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './ViewPackage.scss';

function ViewPackageComponent(props) {
  const { packageId } = props.match.params;
  const [ packageDetails, setPackageDetails ] = useState( {} );

  useEffect( () => {
    getPackage(packageId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] );

  /**
   * Get package details
   * @param {string} [packageId]
   */
  const getPackage = (packageId) => {
    if (! ACL.CLIENT.DOCUMENTS.VIEW.hasAccess()) {
      return ;
    }

    getPackageDetailsApi( {
      packageId: packageId,
      pagination: {
        page_context: PAGE_CONTEXTS.DOCUMENTS.VIEW,
      },
      notificationId: NOTIFICATION_VIEW_DOCUMENT
    } ).then( (response) => {
      setPackageDetails( response.data );
    } );
  };

  return (
    <DashboardLayout
      className="view-package"
      location={props.location}
      pageTitle={<FormattedMessage id="app.dashboard.page_title"/>}
      workspace
    >
      <PageWorkspace className="package-detail-workspace">
        <PageHeader
          title={(
            <>
              <FormattedMessage id="pages.documents.viewPackage.title"/>
              <span>{`: ${packageDetails.name ? packageDetails.name : ""}`}</span>
            </>
          )}
        />
        <div className="package-detail-notifications">
          <Messages notificationId={NOTIFICATION_VIEW_DOCUMENT}/>
        </div>
        <PageSurface className="package-detail-surface">
          {ACL.CLIENT.DOCUMENTS.VIEW.hasAccess() && packageDetails && (
            <PackageDetails
              location={props.location}
              packageDetails={packageDetails}
            />
          )}
          {! ACL.CLIENT.DOCUMENTS.VIEW.hasAccess() && <NoRights/>}
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  );
}

const mapStateToProps = (state) => ( {} );

const ViewPackage = connect( mapStateToProps, null )( ViewPackageComponent );

export { ViewPackage, ViewPackageComponent };
